import { render, staticRenderFns } from "./AddOneConsult.vue?vue&type=template&id=1da950bb&scoped=true"
import script from "./AddOneConsult.vue?vue&type=script&lang=js"
export * from "./AddOneConsult.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AddOneConsult.vue?vue&type=style&index=1&id=1da950bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da950bb",
  null
  
)

export default component.exports